import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DprSignatureReport } from '@report/models';
import { DprApprover } from '@shared/models/dpr';
import { Approver } from '@shared/models/project-setup';

@Component({
  selector: 'app-report-print-signatures',
  templateUrl: './report-print-signatures.component.html',
  styleUrls: ['./report-print-signatures.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportPrintSignaturesComponent implements OnInit {
  @Input({ required: true }) approverList: Approver[];
  @Input({ required: true }) dprApprovers: DprApprover[];

  signatureReport: DprSignatureReport[] = [];

  ngOnInit(): void {
    this.dprApprovers.forEach((dprApprover) => {
      const approver = (this.approverList ?? []).find(
        (x) => x.isActive && x.id === dprApprover.approverId
      );

      if (approver) {
        this.signatureReport.push({
          name: dprApprover.name,
          approver: approver.name,
        });
      }
    });
  }
}
